import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ExploreSelectedIcon = props => (
    <SvgIcon {...props} viewBox="0 0 18 18">
        <path
            d="M9.00022 12.4637L2.35345 16.25L9.00022 1.75L15.6465 16.25L9.00022 12.4637Z"
            fill="#33FF66"
        />
    </SvgIcon>
);

export default ExploreSelectedIcon;
